(function () {
  "use strict";
  var STORAGE_KEY = "pe_fitment_vehicle";
  var treePromise = null;

  function getTree(url) {
    if (treePromise) return treePromise;
    treePromise = fetch(url, { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error("tree " + r.status); return r.json(); })
      .catch(function (e) { treePromise = null; throw e; });
    return treePromise;
  }

  function clean(s) { return (s == null ? "" : String(s)).trim(); }

  function pickDisplay(variants) {
    return variants.slice().sort(function (a, b) {
      var la = (a.match(/[a-z]/g) || []).length;
      var lb = (b.match(/[a-z]/g) || []).length;
      if (lb !== la) return lb - la;
      if (a.length !== b.length) return a.length - b.length;
      return a.localeCompare(b);
    })[0];
  }

  function normalize(tree) {
    var makes = {};
    Object.keys(tree).forEach(function (rawMake) {
      var mk = clean(rawMake);
      if (!mk) return;
      var makeKey = mk.toLowerCase();
      if (!makes[makeKey]) makes[makeKey] = { rawSet: {}, models: {} };
      makes[makeKey].rawSet[mk] = 1;
      var models = tree[rawMake] || {};
      Object.keys(models).forEach(function (rawModel) {
        var md = clean(rawModel);
        if (!md) return;
        var modelKey = md.toLowerCase();
        var M = makes[makeKey].models;
        if (!M[modelKey]) M[modelKey] = { rawSet: {}, years: {} };
        M[modelKey].rawSet[md] = 1;
        (models[rawModel] || []).forEach(function (y) {
          var n = parseInt(y, 10);
          if (!isNaN(n)) M[modelKey].years[n] = 1;
        });
      });
    });
    var out = {};
    Object.keys(makes).forEach(function (mkKey) {
      var raws = Object.keys(makes[mkKey].rawSet);
      var modelsOut = {};
      var Mo = makes[mkKey].models;
      Object.keys(Mo).forEach(function (mdKey) {
        var mraws = Object.keys(Mo[mdKey].rawSet);
        var years = Object.keys(Mo[mdKey].years).map(Number).sort(function (a, b) { return a - b; });
        modelsOut[mdKey] = { display: pickDisplay(mraws), raws: mraws, years: years };
      });
      out[mkKey] = { display: pickDisplay(raws), raws: raws, models: modelsOut };
    });
    return out;
  }

  function fillSelect(sel, items, placeholder) {
    sel.innerHTML = "";
    var opt = document.createElement("option");
    opt.value = ""; opt.textContent = placeholder;
    sel.appendChild(opt);
    items.forEach(function (it) {
      var o = document.createElement("option");
      o.value = it.value; o.textContent = it.label;
      sel.appendChild(o);
    });
  }

  function buildFilterParams(makeRaws, modelRaws, year) {
    var p = [];
    makeRaws.forEach(function (v) { p.push("filter.p.m.custom.make=" + encodeURIComponent(v)); });
    modelRaws.forEach(function (v) { p.push("filter.p.m.custom.model=" + encodeURIComponent(v)); });
    p.push("filter.p.m.custom.year_multi_selects=" + encodeURIComponent(year));
    return p.join("&");
  }

  function buildUrl(mode, handle, makeRaws, modelRaws, year, makeDisp, modelDisp) {
    if (mode === "search") {
      var q = [makeDisp, modelDisp, year].join(" ");
      return "/search?q=" + encodeURIComponent(q) + "&type=product&options%5Bprefix%5D=last";
    }
    return "/collections/" + (handle || "all") + "?" + buildFilterParams(makeRaws, modelRaws, year);
  }

  // Live result count via the Section Rendering API (same mechanism the native
  // facets use). Returns a Promise<number>. Degrades gracefully on failure.
  function fetchCount(handle, params) {
    var u = "/collections/" + (handle || "all") + "?section_id=product-grid&" + params;
    return fetch(u, { headers: { Accept: "text/html" } })
      .then(function (r) { if (!r.ok) throw new Error("count " + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var pc = doc.getElementById("ProductCount");
        if (pc) {
          var m = (pc.textContent || "").replace(/,/g, "").match(/\d+/);
          if (m) return parseInt(m[0], 10);
        }
        var items = doc.querySelectorAll("#product-grid .grid-item-block, #product-grid li.grid-item-block, .product-grid .grid-item-block");
        return items.length;
      });
  }

  function saveVehicle(v) { try { localStorage.setItem(STORAGE_KEY, JSON.stringify(v)); } catch (e) {} }
  function readVehicle() { try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null"); } catch (e) { return null; } }
  function clearVehicle() { try { localStorage.removeItem(STORAGE_KEY); } catch (e) {} }

  function initFinder(root) {
    var url = root.getAttribute("data-tree-url");
    var mode = root.getAttribute("data-result-mode") || "collection_filters";
    var handle = root.getAttribute("data-collection") || "all";
    var makeSel = root.querySelector("[data-fitment-make]");
    var modelSel = root.querySelector("[data-fitment-model]");
    var yearSel = root.querySelector("[data-fitment-year]");
    var submit = root.querySelector("[data-fitment-submit]");
    var status = root.querySelector("[data-fitment-status]");
    if (!makeSel || !modelSel || !yearSel || !submit) return;

    var countToken = 0;
    var submitLabel = (submit.textContent || "Find My Engine").trim();

    function setStatus(msg, state) {
      if (!status) return;
      status.textContent = msg || "";
      if (state) { status.setAttribute("data-state", state); }
      else { status.removeAttribute("data-state"); }
    }
    function reset(sel) { sel.disabled = true; sel.selectedIndex = 0; }

    reset(modelSel); reset(yearSel); submit.disabled = true;
    makeSel.disabled = true;
    setStatus("Loading vehicle data\u2026", "loading");

    function maybeCount() {
      var ok = !!(makeSel.value && modelSel.value && yearSel.value);
      submit.disabled = !ok;
      if (!ok) { setStatus(""); return; }
      var model = root._peModel;
      var mk = model[makeSel.value];
      var md = mk.models[modelSel.value];
      var year = yearSel.value;
      var label = year + " " + mk.display + " " + md.display;
      if (mode !== "collection_filters") {
        setStatus("Ready \u2014 tap \u201c" + submitLabel + "\u201d to see results.", "success");
        return;
      }
      var myToken = ++countToken;
      setStatus("Checking availability\u2026", "loading");
      fetchCount(handle, buildFilterParams(mk.raws, md.raws, year)).then(function (n) {
        if (myToken !== countToken) return;
        if (n > 0) {
          setStatus("\u2713 " + n + " engine" + (n === 1 ? "" : "s") + " fit your " + label + ". Tap \u201c" + submitLabel + "\u201d to view.", "success");
        } else {
          setStatus("No exact matches for " + label + ". Try a different year, or tap \u201c" + submitLabel + "\u201d to see the closest options.", "empty");
        }
      }).catch(function () {
        if (myToken !== countToken) return;
        setStatus(""); // graceful: no count available, Apply still works
      });
    }

    getTree(url).then(function (tree) {
      var model = normalize(tree);
      root._peModel = model;

      var makeItems = Object.keys(model).map(function (k) { return { value: k, label: model[k].display }; })
        .sort(function (a, b) { return a.label.localeCompare(b.label); });
      fillSelect(makeSel, makeItems, makeSel.getAttribute("data-placeholder") || "Make");
      makeSel.disabled = false;
      setStatus("");

      makeSel.addEventListener("change", function () {
        var mk = model[makeSel.value];
        reset(yearSel); submit.disabled = true; setStatus("");
        if (!mk) { reset(modelSel); return; }
        var items = Object.keys(mk.models).map(function (k) { return { value: k, label: mk.models[k].display }; })
          .sort(function (a, b) { return a.label.localeCompare(b.label); });
        fillSelect(modelSel, items, modelSel.getAttribute("data-placeholder") || "Model");
        modelSel.disabled = false;
      });

      modelSel.addEventListener("change", function () {
        var mk = model[makeSel.value]; submit.disabled = true; setStatus("");
        if (!mk || !mk.models[modelSel.value]) { reset(yearSel); return; }
        var yrs = mk.models[modelSel.value].years.slice().sort(function (a, b) { return b - a; });
        fillSelect(yearSel, yrs.map(function (y) { return { value: String(y), label: String(y) }; }), yearSel.getAttribute("data-placeholder") || "Year");
        yearSel.disabled = false;
      });

      yearSel.addEventListener("change", maybeCount);

      var prev = readVehicle();
      if (prev && prev.mkKey && model[prev.mkKey]) {
        makeSel.value = prev.mkKey; makeSel.dispatchEvent(new Event("change"));
        if (prev.mdKey && model[prev.mkKey].models[prev.mdKey]) {
          modelSel.value = prev.mdKey; modelSel.dispatchEvent(new Event("change"));
          if (prev.year) { yearSel.value = String(prev.year); yearSel.dispatchEvent(new Event("change")); }
        }
      }
    }).catch(function () {
      setStatus("Vehicle data could not be loaded. Please try again later.", "error");
      makeSel.disabled = true;
    });

    function go() {
      var model = root._peModel; if (!model) return;
      var mk = model[makeSel.value]; if (!mk) return;
      var md = mk.models[modelSel.value]; if (!md) return;
      var year = yearSel.value; if (!year) return;
      var target = buildUrl(mode, handle, mk.raws, md.raws, year, mk.display, md.display);
      saveVehicle({ mkKey: makeSel.value, mdKey: modelSel.value, year: year, mk: mk.display, md: md.display, makeRaws: mk.raws, modelRaws: md.raws, mode: mode, handle: handle, url: target });
      setStatus("\u2713 Showing engines for " + year + " " + mk.display + " " + md.display + "\u2026", "success");
      window.location.href = target;
    }

    submit.addEventListener("click", function (e) { e.preventDefault(); go(); });
    var form = root.querySelector("form");
    if (form) form.addEventListener("submit", function (e) { e.preventDefault(); go(); });
  }

  function initBanner(banner) {
    var v = readVehicle();
    var labelEl = banner.querySelector("[data-fitment-banner-label]");
    var shopBtn = banner.querySelector("[data-fitment-banner-shop]");
    var changeBtn = banner.querySelector("[data-fitment-banner-change]");
    var clearBtn = banner.querySelector("[data-fitment-banner-clear]");
    if (!v || !v.mk || !v.md || !v.year) { banner.hidden = true; return; }
    banner.hidden = false;
    if (labelEl) labelEl.textContent = v.year + " " + v.mk + " " + v.md;
    if (shopBtn && v.url) shopBtn.setAttribute("href", v.url);
    if (changeBtn) changeBtn.addEventListener("click", function (e) {
      e.preventDefault();
      var f = document.getElementById("fitment-finder");
      if (f) { f.scrollIntoView({ behavior: "smooth", block: "start" }); }
      else { window.location.href = "/pages/find-your-engine#fitment-finder"; }
    });
    if (clearBtn) clearBtn.addEventListener("click", function (e) {
      e.preventDefault(); clearVehicle(); banner.hidden = true;
    });
  }

  function init() {
    var finders = document.querySelectorAll("[data-fitment-finder]");
    for (var i = 0; i < finders.length; i++) initFinder(finders[i]);
    var banners = document.querySelectorAll("[data-fitment-banner]");
    for (var j = 0; j < banners.length; j++) initBanner(banners[j]);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else { init(); }
})();
